import {TableViews} from "./TableViews";
import {Modals} from "../Modals";
import Utilities from "../Utilities";
import {Alerts} from "../Alerts";
import {StockTake} from "../StockTake";

export class TableParams {
    static usersTable(params, element) {

        return {
            columns: [
                {
                    title: "Name",
                    data: "name",
                    name: "name",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 1
                },
                {
                    title: "Date Created",
                    data: "created_at",
                    name: "created_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    render: data => {
                        return TableViews.date_time(data);
                    }
                },
                {
                    title: "Email address",
                    data: "email",
                    name: "email",
                    filter: {
                        type: "text"
                    }
                },
                {
                    title: "Access Level",
                    data: "role.label",
                    name: "role.label",
                    sortable: false,
                    filter: {
                        type: "access_levels"
                    },
                    defaultContent: ''
                },
                {
                    title: "Last Updated",
                    data: "updated_at",
                    name: "updated_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    render: data => {
                        return TableViews.date_difference(data);
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('update') <= -1)
                            return '';

                        return TableViews.edit_btn("/settings/users/" + data + "/edit", "editUserCard", "<i class='fal fa-pencil-alt'></i>", "Edit");
                    },
                    responsivePriority: 2
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('delete') <= -1)
                            return '';

                        return TableViews.delete_btn("/settings/users/" + data);
                    },
                    responsivePriority: 3
                }
            ]
        }
    }

    static companiesTable(params, element) {

        return {
            columns: [
                {
                    title: "Name",
                    data: "name",
                    name: "name",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 1,
                    render: (data, type, row) => {
                        return '<a href="/settings/companies/' + row['id'] + '">' + data + '</a>';
                    }
                },
                {
                    title: "Date Created",
                    data: "created_at",
                    name: "created_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    render: data => {
                        return TableViews.date_time(data);
                    }
                },
                {
                    title: "Company Name",
                    data: "name",
                    name: "name",
                    filter: {
                        type: "text"
                    }
                },
                {
                    title: "VAT Number",
                    data: "vat_no",
                    name: "vat_no",
                    filter: {
                        type: "text"
                    }
                },
                {
                    title: "Company Number",
                    data: "company_no",
                    name: "company_no",
                    filter: {
                        type: "text"
                    }
                },
                {
                    title: "Invoice Prefix",
                    data: "invoice_prefix",
                    name: "invoice_prefix",
                    filter: {
                        type: "text"
                    }
                },
                {
                    title: "Stripe Key",
                    data: "stripe_key",
                    name: "stripe_key",
                    filter: {
                        type: "text"
                    }
                },
                {
                    title: "Last Updated",
                    data: "updated_at",
                    name: "updated_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    render: data => {
                        return TableViews.date_difference(data);
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('update') <= -1)
                            return '';

                        return TableViews.edit_btn("/settings/companies/" + data + "/edit", "editCompanyCard", "<i class='fal fa-pencil-alt'></i>", "Edit");
                    },
                    responsivePriority: 2
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('delete') <= -1)
                            return '';

                        return TableViews.delete_btn("/settings/companies/" + data);
                    },
                    responsivePriority: 3
                }
            ]
        }
    }

    static customerGroupsTable(params, element) {

        return {
            columns: [
                {
                    title: "Customer Group Name",
                    data: "name",
                    name: "name",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 1
                },
                {
                    title: "Date Created",
                    data: "created_at",
                    name: "created_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    render: data => {
                        return TableViews.date_time(data);
                    }
                },
                {
                    title: "Customer Default Group",
                    data: "default",
                    name: "default",
                    render: data => {
                        return (data === 1 ? '<span><i class="fas fa-check-circle"></i></span>' : '');
                    }
                },
                {
                    title: "Last Updated",
                    data: "updated_at",
                    name: "updated_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    render: data => {
                        return TableViews.date_difference(data);
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('update') <= -1)
                            return '';

                        return TableViews.edit_btn("/customers/groups/" + data + "/edit", "editCustomerGroupCard", "<i class='fal fa-pencil-alt'></i>", "Edit");
                    },
                    responsivePriority: 2
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('delete') <= -1)
                            return '';

                        return TableViews.delete_btn("/customers/groups/" + data);
                    },
                    responsivePriority: 3
                }
            ]
        }
    }

    static customersTable(params, element) {

        return {
            columns: [
                {
                    title: "ID",
                    data: "id",
                    name: "id",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 1
                },
                {
                    title: "First Name",
                    data: "first_name",
                    name: "first_name",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 1
                },
                {
                    title: "Last Name",
                    data: "last_name",
                    name: "last_name",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 1
                },
                {
                    title: "Email",
                    data: "email",
                    name: "email",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 1
                },
                {
                    title: "Date Created",
                    data: "created_at",
                    name: "created_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    render: data => {
                        return TableViews.date_time(data);
                    }
                },
                {
                    title: "Last Updated",
                    data: "updated_at",
                    name: "updated_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    render: data => {
                        return TableViews.date_difference(data);
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('update') <= -1)
                            return '';

                        // return TableViews.edit_btn("/customers/" + data + "/edit", "editCustomerCard", "<i class='fal fa-pencil-alt'></i>", "Edit");
                        return '<a href="/customers/' + data + '" class="btn btn-primary"><i class=\'fal fa-pencil-alt\'></i></a>'
                    },
                    responsivePriority: 2
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('delete') <= -1)
                            return '';

                        return TableViews.delete_btn("/customers/" + data);
                    },
                    responsivePriority: 3
                }
            ]
        }
    }

    static customerAddressesTable(params, element) {

        return {
            columns: [
                {
                    title: "Line 1",
                    data: "line_1",
                    name: "line_1",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 1
                },
                {
                    title: "Line 2",
                    data: "line_2",
                    name: "line_2",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 2
                },
                {
                    title: "Line 3",
                    data: "line_3",
                    name: "line_3",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 2
                },
                {
                    title: "Postcode",
                    data: "postcode",
                    name: "postcode",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 1
                },
                {
                    title: "Phone",
                    data: "value",
                    name: "value",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 1
                },
                {
                    title: "First Name",
                    data: "first_name",
                    name: "first_name",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 2
                },
                {
                    title: "Last Name",
                    data: "last_name",
                    name: "last_name",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 2
                },
                {
                    title: "Default Shipping",
                    data: "default_shipping",
                    name: "default_shipping",
                    render: data => {
                        return (data ? '<span><i class="fas fa-check-circle"></i></span>' : '');
                    }
                },
                {
                    title: "Default Billing",
                    data: "default_billing",
                    name: "default_billing",
                    render: data => {
                        return (data ? '<span><i class="fas fa-check-circle"></i></span>' : '');
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('update') <= -1)
                            return '';
                        return TableViews.edit_btn("/customers/" + row['customer_id'] + "/addresses/" + data + "/edit", "editCustomerAddressCard", "<i class='fal fa-pencil-alt'></i>", "Edit");
                    },
                    responsivePriority: 2
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('delete') <= -1)
                            return '';
                        return TableViews.delete_btn("/customers/" + row['customer_id'] + "/addresses/" + data);
                    },
                    responsivePriority: 3
                }
            ]
        }
    }

    static companiesChannelsTable(params, element) {

        return {
            columns: [
                {
                    title: "Name",
                    data: "name",
                    name: "name",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 1
                },
                {
                    title: "Base URL",
                    data: "base_url",
                    name: "base_url",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 1
                },
                {
                    title: "Type",
                    data: "type",
                    name: "type",
                },
                {
                    title: "Date Created",
                    data: "created_at",
                    name: "created_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    render: data => {
                        return TableViews.date_time(data);
                    }
                },
                {
                    title: "Last Updated",
                    data: "updated_at",
                    name: "updated_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    render: data => {
                        return TableViews.date_difference(data);
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('update') <= -1)
                            return '';

                        return TableViews.edit_btn("/settings/companies/" + row['company_id'] + "/channels/" + row['id'] + "/edit", "editChannelCard", "<i class='fal fa-pencil-alt'></i>", "Edit");
                    },
                    responsivePriority: 2
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('delete') <= -1)
                            return '';

                        return TableViews.delete_btn("/settings/companies/" + row['company_id'] + "/channels/" + row['id']);
                    },
                    responsivePriority: 3
                }
            ]
        }
    }

    static stockLocationsTable(params, element) {

        return {
            columns: [
                {
                    title: "Name",
                    data: "name",
                    name: "name",
                    filter: {
                        type: "text"
                    },
                    defaultContent: "empty"
                },
                {
                    title: "Date Created",
                    data: "created_at",
                    name: "created_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    render: data => {
                        return TableViews.date_time(data);
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('update') <= -1)
                            return '';
                        return TableViews.edit_btn("/products/stock-locations/" + data + "/edit", "editStockLocationCard", "<i class='fal fa-pencil-alt'></i>", "Edit");
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('delete') <= -1)
                            return '';
                        return TableViews.delete_btn("/products/stock-locations/" + data);
                    }
                }
            ]
        }
    }

    static suppliersTable(params, element) {

        return {
            columns: [
                {
                    title: "Name",
                    data: "name",
                    name: "name",
                    filter: {
                        type: "text"
                    },
                    defaultContent: "empty"
                },
                {
                    title: "Email",
                    data: "email",
                    name: "email",
                    filter: {
                        type: "text"
                    },
                    defaultContent: "empty"
                },
                {
                    title: "Date Created",
                    data: "created_at",
                    name: "created_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    render: data => {
                        return TableViews.date_time(data);
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        return TableViews.edit_btn("/products/suppliers/" + data + "/edit", "editSupplierCard", "<i class='fal fa-pencil-alt'></i>", "Edit");
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('delete') <= -1)
                            return '';
                        return TableViews.delete_btn("/products/suppliers/" + data);
                    }
                }
            ]
        }
    }

    static rolesTable(params, element) {

        return {
            columns: [
                {
                    title: "Name",
                    data: "label",
                    name: "label",
                    filter: {
                        type: "text"
                    }
                },
                {
                    title: "Date Created",
                    data: "created_at",
                    name: "created_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    render: data => {
                        return TableViews.date_time(data);
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        return TableViews.edit_btn("/settings/roles/" + data + "/edit", "editAccessLevelCard", "<i class='fal fa-pencil-alt'></i>", "Edit");
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        return TableViews.delete_btn("/settings/roles/" + data);
                    }
                }
            ]
        }
    }

    static taxClassesTable(params, element) {

        return {
            columns: [
                {
                    title: "Name",
                    data: "name",
                    name: "name",
                    filter: {
                        type: "text"
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        // if(row['can'].indexOf('show') <= -1)
                        //     return '';

                        return TableViews.edit_btn("/settings/tax/classes/" + data, false, "<i class=\"far fa-eye\"></i>", "Show");
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        // if(row['can'].indexOf('delete') <= -1)
                        //     return '';

                        return TableViews.delete_btn("/settings/tax/classes/" + data);
                    }
                }
            ]
        }
    }

    static taxClassRatesTable(params, element) {

        return {
            columns: [
                {
                    title: "Name",
                    data: "name",
                    name: "name",
                    filter: {
                        type: "text"
                    }
                },
                {
                    title: "Country",
                    data: "country.name",
                    name: "country_id",
                    filter: {
                        type: "countries"
                    },
                    defaultContent: ''
                },
                {
                    title: "Postcode(s)",
                    data: "postcodesStringify",
                    name: "postcodesStringify",
                    filter: {
                        type: "text"
                    }
                },
                {
                    title: "Rate (%)",
                    data: "percent_rate",
                    name: "percent_rate",
                    filter: {
                        type: "percent"
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        // if(row['can'].indexOf('show') <= -1)
                        //     return '';

                        return TableViews.edit_btn("/settings/tax/classes/" + row.tax_class_id + '/rates/' + data + '/edit', 'editTaxRateCard', "<i class='fal fa-pencil-alt'></i>", "Edit");
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        // if(row['can'].indexOf('delete') <= -1)
                        //     return '';

                        return TableViews.delete_btn("/settings/tax/classes/" + row.tax_class_id + '/rates/' + data);
                    }
                }
            ]
        }
    }

    static categoriesTable(params, element) {

        return {
            columns: [
                {
                    title: "Name",
                    data: "name",
                    name: "name",
                    filter: {
                        type: "text"
                    }
                },
                {
                    title: "Description",
                    data: "description",
                    name: "description",
                    filter: {
                        type: "text"
                    },
                    render: (data, type, row) => {

                        return data ? TableViews.wysiwyg(data) : ''
                    }
                },
                {
                    title: "Parent",
                    data: "parent_id",
                    name: "parent_id",
                    filter: {
                        type: "categories"
                    },
                    render: (data, type, row) => {

                        return data ? row.parent.name : '';
                    },
                },
                {
                    title: "Display",
                    data: "display",
                    name: "display",
                    filter: {
                        type: "yesNo"
                    },
                    render: (data, type, row) => {
                        return data ? 'Yes' : 'No';
                    },
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        // if(row['can'].indexOf('show') <= -1)
                        //     return '';

                        return TableViews.edit_btn("/products/categories/" + data + '/edit', 'editCategoryCard', "<i class='fal fa-pencil-alt'></i>", "Edit");
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        // if(row['can'].indexOf('delete') <= -1)
                        //     return '';

                        return TableViews.delete_btn("/products/categories/" + data);
                    }
                }
            ]
        }
    }

    static productsTable(params, element) {

        return {
            columns: [
                {
                    title: "Name",
                    data: "name",
                    name: "name",
                    filter: {
                        type: "text"
                    }
                },
                {
                    title: "Description",
                    data: "description.content",
                    name: "description.content",
                    filter: {
                        type: "text"
                    },
                    defaultContent: "",
                    render: (data, type, row) => {

                        return data ? TableViews.wysiwyg(data) : ''
                    }
                },
                {
                    title: "Products (SKU)",
                    data: "skus",
                    filter: {
                        type: "text"
                    },
                },
                {
                    title: "Supplier(s)",
                    data: "product_suppliers",
                    name: "product_suppliers",
                    filter: {
                        type: "text"
                    },
                    defaultContent: "",
                },
                {
                    title: "Supplier (SKU)",
                    data: "supplier_skus",
                    name: "supplier_skus",
                    filter: {
                        type: "text"
                    },
                    defaultContent: "",
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('update') <= -1)
                            return '';

                        return TableViews.edit_btn("/products/" + data + '/edit', false, "<i class='fal fa-pencil-alt'></i>", "Edit");
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (!row.stock_can)
                            return '';
                        return `<a href="/products/${data}/stock-logs" class="btn btn-primary">Stock</a>`;
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('delete') <= -1)
                            return '';

                        if (row.is_sync_blocked)
                            return '';

                        return TableViews.delete_btn("/products/" + data);
                    }
                }
            ]
        }
    }

    static attributesTable(params, element) {

        return {
            columns: [
                {
                    title: "Name",
                    data: "name",
                    name: "name",
                    filter: {
                        type: "text"
                    }
                },
                {
                    title: "Terms",
                    data: "termsStringify",
                    name: "termsStringify",
                    filter: {
                        type: "text"
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        // if(row['can'].indexOf('show') <= -1)
                        //     return '';

                        return TableViews.edit_btn("/products/attributes/" + data + '/edit', false, "<i class='fal fa-pencil-alt'></i>", "Edit");
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('delete') <= -1)
                            return '';

                        return TableViews.delete_btn("/products/attributes/" + data);
                    }
                }
            ]
        }
    }

    static termsTable(params, element) {

        return {
            columns: [
                {
                    title: "Name",
                    data: "name",
                    name: "name",
                    filter: {
                        type: "text"
                    }
                },
                {
                    title: "Description",
                    data: "description",
                    name: "description",
                    filter: {
                        type: "text"
                    },
                    render: (data, type, row) => {

                        return data ? TableViews.wysiwyg(data) : ''
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        // if(row['can'].indexOf('show') <= -1)
                        //     return '';

                        return TableViews.edit_btn("/products/attributes/" + row.attribute_id + '/terms/' + data + '/edit', 'editTermCard', "<i class='fal fa-pencil-alt'></i>", "Edit");
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        // if(row['can'].indexOf('delete') <= -1)
                        //     return '';

                        return TableViews.delete_btn("/products/attributes/" + row.attribute_id + '/terms/' + data);
                    }
                }
            ]
        }
    }

    static shippingZonesTable(params, element) {
        return {
            columns: [
                {
                    sortable: false,
                    title: "Name",
                    data: "name",
                    name: "name",
                    filter: {
                        type: "text"
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('update') <= -1)
                            return '';

                        return '<a class="btn btn-primary" href="/settings/shipping/zones/' + row['id'] + '"><i class="fal fa-pencil-alt" aria-hidden="true"></i></a>';
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('delete') <= -1)
                            return '';

                        return TableViews.delete_btn("/settings/shipping/zones/" + data);
                    }
                },
                {
                    title: "",
                    data: 'id',
                    sortable: false,
                    render: (data, type, row) => {
                        return '<div><i class="handle fas fa-arrows-alt-v"></i></div>';
                    }
                }
            ]
        }
    }

    static shippingRatesTable(params, element) {
        return {
            columns: [
                {
                    title: "Name",
                    data: "name",
                    name: "name",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 1
                },
                {
                    title: "Description",
                    data: "description",
                    name: "description",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 3
                },
                {
                    title: "Free Shipping Rate",
                    data: "free_shipping_price",
                    name: "free_shipping_price",
                    render: data => {
                        return (data ? '<span><i class="fas fa-check-circle"></i></span>' : '');
                    }
                },
                {
                    title: "Taxable",
                    data: "taxable",
                    name: "taxable",
                    render: data => {
                        return (data ? '<span><i class="fas fa-check-circle"></i></span>' : '');
                    }
                },
                {
                    title: "Enabled",
                    data: "enabled",
                    name: "enabled",
                    render: data => {
                        return (data ? '<span><i class="fas fa-check-circle"></i></span>' : '');
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('update') <= -1)
                            return '';
                        return TableViews.edit_btn("/settings/shipping/zones/" + row['shipping_zone_id'] + '/rates/' + data + '/edit', 'editShippingRateCard', "<i class='fal fa-pencil-alt'></i>", "Edit");
                    },
                    responsivePriority: 3
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('delete') <= -1)
                            return '';
                        return TableViews.delete_btn("/settings/shipping/zones/" + row['shipping_zone_id'] + "/rates/" + data);
                    },
                    responsivePriority: 3
                },
            ]
        }
    }

    static invoicesTable(params, element) {

        return {
            ordering: false,
            columns: [
                {
                    title: "Invoice No",
                    data: "invoice_number",
                    name: "invoice_number",
                    filter: {
                        type: "text"
                    },
                    sortable: false,
                    defaultContent: "",
                    responsivePriority: 1
                },
                {
                    title: "Ref",
                    data: "reference",
                    name: "reference",
                    filter: {
                        type: "text"
                    },
                    sortable: false,
                    defaultContent: "empty",
                    responsivePriority: 1
                },
                {
                    title: "Company",
                    data: "company.name",
                    name: "company.name",
                    defaultContent: "",
                    responsivePriority: 2,
                    // render: data => {
                    //     return TableViews.monetary(data);
                    // }
                },
                {
                    title: "Sub Total",
                    data: "overall_sub_total",
                    name: "overall_sub_total",
                    defaultContent: "empty",
                    responsivePriority: 2,
                    render: data => {
                        return TableViews.monetary(data);
                    }
                },
                {
                    title: "VAT",
                    data: "overall_vat",
                    name: "overall_vat",
                    defaultContent: "empty",
                    responsivePriority: 2,
                    render: data => {
                        return TableViews.monetary(data);
                    }
                },
                {
                    title: "Total",
                    data: "overall_total",
                    name: "overall_total",
                    defaultContent: "empty",
                    responsivePriority: 2,
                    render: data => {
                        return TableViews.monetary(data);
                    }
                },
                {
                    title: "Date Due",
                    data: "date_due",
                    name: "date_due",
                    filter: {
                        type: "daterangepicker"
                    },
                    responsivePriority: 2,
                    render: data => {
                        return TableViews.date(data);
                    }
                },
                {
                    title: "Status",
                    data: "status",
                    name: "status",
                    responsivePriority: 2
                },
                {
                    title: "Date Created",
                    data: "created_at",
                    name: "created_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    responsivePriority: 2,
                    render: data => {
                        return TableViews.date_time(data);
                    }
                },
                {
                    title: "Type",
                    data: "relation_type",
                    name: "relation_type",
                    responsivePriority: 2,
                    render: data => {
                        if (!data)
                            return 'Manual';
                        if (data.indexOf('order'))
                            return 'Order'
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        return '<a class="btn btn-primary" href="/financials/invoice/user-download/' + data + '" target="_blank" rel="noopener noreferrer"><i class="fas fa-download"></i></a>';
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('update') <= -1)
                            return '';

                        return TableViews.edit_btn("/financials/invoices/" + data + "/edit", "editInvoiceCard", "<i class='fal fa-pencil-alt'></i>", "Edit");
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('delete') <= -1)
                            return '';

                        return TableViews.delete_btn("/financials/invoices/" + data);
                    }
                }
            ]
        }
    }

    static stockSummaryTable(params, element) {

        return {
            ordering: false,
            paging: false,
            columns: [
                {
                    title: "Stock Location",
                    name: "stock_location_id",
                    data: "stock_location_id",
                    filter: {
                        type: "stockLocation"
                    },
                    responsivePriority: 2,
                    render: (data, type, row) => {
                        return row.stock_location_name ? row.stock_location_name : 'Online Orders';
                    },
                    defaultContent: '',

                },
                {
                    title: "Stock Count",
                    data: "count",
                    name: "count",
                    responsivePriority: 1
                }
            ]
        }
    }

    static variableStockSummaryTable() {
        let options = this.stockSummaryTable();

        options.columns.unshift(
            {
                title: "Name",
                name: "product.id",
                data: "product.name",
                filter: {
                    type: "variableProducts"
                },
                responsivePriority: 2,
                render: (data, type, row) => {
                    return row.product.name;
                }
            },
            {
                title: "SKU",
                name: "product.id",
                data: "product.sku",
                filter: {
                    type: "variableProducts",
                    label: "sku"
                },
                responsivePriority: 2,
                render: (data, type, row) => {
                    return row.product.sku;
                }
            }
        )
        return options;
    }

    static stockLogTable(params, element) {

        return {
            ordering: false,
            columns: [
                {
                    title: "Location",
                    name: "stock_location_id",
                    data: "stock_location_id",
                    filter: {
                        type: "stockLocation"
                    },
                    responsivePriority: 2,
                    render: (data, type, row) => {
                        return row.stock_location_name ? row.stock_location_name : 'Online Order';
                    }
                },
                {
                    title: "Description",
                    data: "description",
                    name: "description",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 3
                },
                // {
                //     title: "Reason",
                //     data: "reason",
                //     name: "reason",
                //     filter: {
                //         type: "text"
                //     },
                //     responsivePriority: 3
                // },
                {
                    title: "Adjustment Amount",
                    data: "quantity",
                    name: "quantity",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 2,
                    render: (data, type, row) => {
                        if (data > 0)
                            return '+' + data;
                        return data;
                    }
                },
                {
                    title: "Previous Total",
                    data: "previous_total",
                    name: "previous_total",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 2,
                    defaultContent: '',
                },
                {
                    title: "Supplier",
                    data: "supplier_id",
                    name: "supplier_id",
                    responsivePriority: 2,
                    filter: {
                        type: "suppliers"
                    },
                    render: (data, type, row) => {
                        return row.supplier_name ?? '';
                    }
                },
                {
                    title: "Adjustment By",
                    data: "auth_id",
                    name: "auth_id",
                    responsivePriority: 2,
                    filter: {
                        type: "users"
                    },
                    render: (data, type, row) => {
                        return row.auth ? row.auth.name : '';
                    }
                },
                {
                    title: "Date Created",
                    data: "created_at",
                    name: "created_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    render: data => {
                        return TableViews.date_time(data);
                    },
                    responsivePriority: 2
                },
                // {
                //     data: "id",
                //     sortable: false,
                //     className: "actions",
                //     render: (data, type, row) => {
                //         if(row['can'].indexOf('delete') <= -1)
                //             return '';
                //         return TableViews.delete_btn("/products/" + row['product_id'] + "/stock-logs/" + row['id']);
                //     },
                //     responsivePriority: 3
                // }
            ]
        }
    }

    static variableStockLogTable(params, element) {
        let options = this.stockLogTable();

        options.columns.unshift(
            {
                title: "Name",
                name: "product.name",
                data: "product.name",
                filter: {
                    type: "variableProducts"
                },
                responsivePriority: 2
            },
            {
                title: "SKU",
                name: "product.id",
                data: "product.sku",
                filter: {
                    type: "variableProducts",
                    label: "sku"
                },
                responsivePriority: 2,
                render: (data, type, row) => {
                    return row.product.sku;
                }
            }
        )
        return options;
    }

    static customerOrdersTable(params, element){
        let options = TableParams.ordersTable(params, element)

        options.columns = options.columns.filter((item) => {
            return !(item.title === 'Customer' || item.title === 'Customer Group')
        })

        return options
    }

    static ordersTable(params, element) {

        return {
            ordering: false,
            columns: [
                {
                    'data': 'id',
                    title: "#",
                    filter: {
                        type: "text"
                    },
                    defaultContent: 'N/A',
                    responsivePriority: 1
                },
                {
                    title: "Company",
                    data: "company.name",
                    name: "company_id",
                    filter: {
                        type: "companies"
                    },
                    defaultContent: 'N/A',
                    responsivePriority: 1
                },
                {
                    title: "Customer",
                    name: "customer",
                    filter: {
                        type: "text"
                    },
                    render(createElement, context, row) {
                        return (row.customer ? row.customer.fullname : row.customer_name)
                    },
                    defaultContent: 'Guest',
                    responsivePriority: 1
                },
                {
                    title: "Postcode",
                    name: "postcode",
                    filter: {
                        type: "text"
                    },
                    render(createElement, context, row) {
                        return (row.shipping_address ? row.shipping_address.address.postcode : '')
                    },
                    defaultContent: 'Guest',
                    responsivePriority: 1
                },
                {
                    title: "Customer Group",
                    data: "customer_group.name",
                    name: "customer_group_id",
                    filter: {
                        type: "customerGroups"
                    },
                    responsivePriority: 3
                },
                {
                    title: "Status",
                    data: "status.id",
                    name: "status.id",
                    filter: {
                        type: "statuses"
                    },
                    render(createElement, context, row) {
                        return row.status.label
                    },
                    responsivePriority: 4
                },
                {
                    title: "Order Total",
                    data: "financials",
                    name: "financials",
                    responsivePriority: 4,
                    render: (data, type, row) => {
                        if (row.financials.hasOwnProperty(0))
                            return TableViews.monetary(row.financials[0].overall_total);
                        return '';
                    }
                },
                {
                    title: "Profit",
                    name: "name",
                    responsivePriority: 4,
                    render: (data, type, row) => {
                        if (row.financials.hasOwnProperty(0))
                            return TableViews.monetary(row.profit);
                        return '';
                    },
                    defaultContent: ''
                },
                {
                    title: "Order Type",
                    data: "order_type",
                    name: "order_type",
                    filter: {
                        'type': 'orderType'
                    },
                    responsivePriority: 4,
                    render: data => {
                        return TableViews.smartCapitalise(data);
                    }
                },
                {
                    title: "Date Created",
                    data: "created_at",
                    name: "created_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    responsivePriority: 2,
                    render: data => {
                        return TableViews.date_time(data);
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        return `<a class='btn btn-primary' href="/orders/${data}"><i class="far fa-eye"></i></a>`;
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        // if (row['status']['name'] === 'processing' || row['status']['name'] === 'completed') {
                        //     return `<a class='btn btn-primary' href="/orders/${data}/refunds">Refund</a>`;
                        // }
                        if (row['can'].indexOf('update') <= -1){
                            return ''
                        }

                        return `<a class='btn btn-primary' href="/orders/${data}/edit"><i class='fal fa-pencil-alt'></i></a>`;
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        if (row['can'].indexOf('delete') <= -1)
                            return '';

                        return TableViews.delete_btn("/orders/" + data);
                    }
                }
            ]
        }
    }

    static creditNotesTable(params, element) {
        return {
            // ordering: false,
            columns: [
                {
                    title: "Ref",
                    data: "reference",
                    // name: "reference",
                    filter: {
                        type: "text"
                    },
                    defaultContent: "empty",
                    responsivePriority: 1
                },
                {
                    title: "Sub Total",
                    data: "overall_sub_total",
                    name: "overall_sub_total",
                    filter: {
                        type: "double"
                    },
                    defaultContent: "empty",
                    responsivePriority: 2
                },
                {
                    title: "VAT",
                    data: "overall_vat",
                    name: "overall_vat",
                    filter: {
                        type: "double"
                    },
                    defaultContent: "empty",
                    responsivePriority: 2
                },
                {
                    title: "Total",
                    data: "overall_total",
                    name: "overall_total",
                    filter: {
                        type: "double"
                    },
                    defaultContent: "empty",
                    responsivePriority: 2
                },
                {
                    title: "Date Due",
                    data: "date_due",
                    name: "date_due",
                    filter: {
                        type: "daterangepicker"
                    },
                    responsivePriority: 2,
                    render: data => {
                        return TableViews.date(data);
                    }
                },
                {
                    title: "Status",
                    data: "status",
                    name: "status",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 2
                },
                {
                    title: "Date Created",
                    data: "created_at",
                    name: "created_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    responsivePriority: 2,
                    render: data => {
                        return TableViews.date_time(data);
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        return '<a class="btn btn-primary" href="/financials/credit-note/user-download/' + data + '" target="_blank" rel="noopener noreferrer"><i class="fas fa-download"></i></a>';
                    }
                }
            ]
        }
    }

    static woocommerceShippingClassesTable(params, element) {

        return {
            columns: [
                {
                    title: "Name",
                    data: "name",
                    name: "name",
                    filter: {
                        type: "text"
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        // if(row['can'].indexOf('show') <= -1)
                        //     return '';

                        return TableViews.edit_btn("/settings/shipping/classes/" + data + "/edit", "editShippingClassCard", "<i class='fal fa-pencil-alt'></i>", "Edit");
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        // if(row['can'].indexOf('delete') <= -1)
                        //     return '';

                        return TableViews.delete_btn("/settings/shipping/classes/" + data);
                    }
                }
            ]
        }
    }

    static stockOrdersTable(params, element) {

        return {
            ordering: false,
            columns: [
                {
                    title: "#",
                    data: "id",
                    filter: {
                        type: "text"
                    },
                },
                {
                    title: "Products (SKU)",
                    data: "product_stringify",
                    filter: {
                        type: "productsSKU"
                    },
                },
                {
                    title: "Supplier",
                    data: "supplier_id",
                    name: "supplier_id",
                    filter: {
                        type: "suppliers"
                    },
                    render: (data, type, row) => {
                        return row.supplier ? row.supplier.name : '';
                    }
                },
                {
                    title: "Status",
                    data: "status",
                },
                {
                    title: "Created At",
                    data: "created_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    render: data => {
                        return TableViews.date_time(data);
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        // if(row['can'].indexOf('update') <= -1)
                        //     return '';
                        return '<a class="btn btn-primary" href="/products/stock/orders/' + data + '/download" target="_blank" rel="noopener noreferrer"><i class="fas fa-download"></i></a>';
                    },
                    responsivePriority: 3
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        // if(row['can'].indexOf('update') <= -1)
                        //     return '';
                        return TableViews.edit_btn("/products/stock/orders/" + data, false, "<i class=\"far fa-eye\"></i>", "Show");
                    },
                    responsivePriority: 3
                },

            ]
        }
    }

    static stockOrderProductsTable(params, element) {

        let options = {
            ordering: false,
            "paging": false,
            columns: [
                {
                    title: "Product (SKU)",
                    data: "product.sku",
                    filter: {
                        type: "productsSKU"
                    },
                },
                {
                    title: "New Cost Per Item",
                    data: "new_price",
                    render: (data, type, row) => {
                        return '  <input type="monetary" name="products[' + row.id + '][cost]" class="form-control" value="' + data + '" ' +
                            'placeholder="Received amount" ' + (row.order.completed_at ? "disabled" : '') + '>'
                    },
                },
                {
                    title: "Stock Location",
                    data: null,
                    render: (data, type, row) => {
                        return '<select name="products[' + row.id + '][stock_location_id]" class="form-control" placeholder="Select Stock Location"' +
                            ' data-src="/api/stock-locations" ' + (row.order.completed_at ? "disabled data-selected=" + (row.stock ? row.stock.stock_location_id : "") + "" : "") + ' ></select>'
                    },
                },
                {
                    title: "Received quantity",
                    data: "quantity",
                    name: "quantity",
                    render: (data, type, row) => {
                        return '<div class="input-group mb-3">' +
                            '  <input type="number" class="form-control" min="0" name="products[' + row.id + '][quantity]" value="' +
                            (row.order.completed_at ? (row.stock ? row.stock.quantity : 0) : data) + '" ' +
                            'placeholder="Received amount" ' + (row.order.completed_at ? "disabled" : "") + '>' +
                            '  <div class="input-group-append">' +
                            '    <span class="input-group-text" id="basic-addon2">Ordered - ' + data + '</span>' +
                            '  </div>' +
                            '</div>';
                    },
                },

            ]
        }

        if ($(element).is('[data-button]')) {
            options.dom = 'rtipB'
            options.buttons = [
                {
                    text: 'Confirm Stock Order',
                    class: 'btn',
                    action: function (e, dt, node, config) {
                        $(node).parents('form').submit()
                    }
                }
            ]
        }

        return options;

    }

    static ordersInProcessTable() {
        return {
            ordering: false,
            dom: 'Brtip',
            buttons: [
                {
                    text: 'Print Packing Slips',
                    action: function (e, dt, node, config) {
                        const $body = $(dt.body()[0]);

                        let data = [], url = '/order-processing/package-slips?';

                        $('tr', $body).each((key, row) => {

                            if (!$('.table-checkbox', row).is(':checked'))
                                return false;

                            let rowData = dt.row(row).data();

                            data.push(rowData.id)

                        });

                        if (data.length) {
                            let dataQuery = data.map(function (el, idx) {
                                return 'orders[' + idx + ']=' + el;
                            }).join('&')

                            $('.table-checkbox').prop('checked', false);

                            window.open(url + dataQuery, '_blank').focus()
                        } else {
                            Alerts.error('No orders selected.');
                        }

                    }
                }, {
                    text: 'Print Invoices',
                    action: function (e, dt, node, config) {
                        const $body = $(dt.body()[0]);

                        let data = [], url = '/order-processing/invoices?';

                        $('tr', $body).each((key, row) => {

                            if (!$('.table-checkbox', row).is(':checked'))
                                return false;

                            let rowData = dt.row(row).data();

                            data.push(rowData.id)

                        });

                        if (data.length) {
                            let dataQuery = data.map(function (el, idx) {
                                return 'orders[' + idx + ']=' + el;
                            }).join('&')

                            $('.table-checkbox').prop('checked', false);

                            window.open(url + dataQuery, '_blank').focus()
                        } else {
                            Alerts.error('No orders selected.');
                        }

                    }
                }
            ],
            columns: [
                {
                    title: "#",
                    data: "id",
                    name: "id",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 1
                },
                {
                    title: "Company",
                    data: "company.name",
                    name: "company_id",
                    filter: {
                        type: "companies"
                    },
                    defaultContent: 'N/A',
                    responsivePriority: 1
                },
                {
                    title: "Customer",
                    name: "customer",
                    filter: {
                        type: "text"
                    },
                    render(createElement, context, row) {
                        return (row.customer ? row.customer.fullname : row.customer_name)
                    },
                    defaultContent: 'Guest',
                    responsivePriority: 1
                },
                {
                    title: "Shipping Address",
                    data: "shipping_address.address.address_string",
                    name: "address_string",
                    defaultContent: 'N/A',
                    responsivePriority: 1
                },
                {
                    title: "Shipping Method",
                    data: "items",
                    name: "items",
                    responsivePriority: 4,
                    render: (data, type, row) => {
                        let result = '';
                        data.forEach(function (item) {
                            if ((item.relation_type ?? null) && item.relation_type.indexOf('ShippingRate') >= 0)
                                result = item.relation.name;
                        });
                        return result;
                    }
                },
                {
                    title: "Date Created",
                    data: "created_at",
                    name: "created_at",
                    filter: {
                        type: "daterangepicker"
                    },
                    responsivePriority: 2,
                    render: data => {
                        return TableViews.date_time(data);
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        return `<a class='btn btn-primary' href="/orders/${data}"><i class="far fa-eye"></i></a>`;
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        return TableViews.edit_btn(`/order-processing/${data}/edit`, 'markAsCompletedCard', 'Mark as Completed');
                    }
                },
                {
                    title: '',
                    defaultContent: '',
                    render: (createElement, context) => {
                        return '<div class="form-check alone"><input class="table-checkbox" type="checkbox"/><label></label></div>'
                    }
                }
            ]
        }
    }


    static couponsTable(params, element) {
        return {
            ordering: false,
            columns: [
                {
                    title: "Name",
                    data: "name",
                    filter: {
                        type: "text"
                    },
                },
                {
                    title: "Code",
                    data: "code",
                    filter: {
                        type: "text"
                    },
                },
                {
                    title: "Type",
                    data: "type",
                    filter: {
                        type: "couponType"
                    },
                    render: (data, type, row) => {
                        return Utilities.capitaliseFirstLetter(data)
                    }

                },
                {
                    title: "Discount",
                    data: "value",
                    filter: {
                        type: "text"
                    },
                    render: (data, type, row) => {
                        return (row.type == 'flat' ? '£' : '') + data + (row.type == 'percentage' ? '%' : '')
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        return TableViews.edit_btn(`/settings/coupons/${data}/edit`, 'editCouponCard', "<i class='fal fa-pencil-alt'></i>", "Edit");
                    }
                },
                {
                    data: "id",
                    sortable: false,
                    className: "actions",
                    render: (data, type, row) => {
                        // if(row['can'].indexOf('delete') <= -1)
                        //     return '';

                        return TableViews.delete_btn("/settings/coupons/" + data);
                    },
                }
            ]
        }
    }


    static ordersDashboardTable() {
        return {
            ordering: false,
            columns: [
                {
                    title: "#",
                    data: "id",
                    name: "id",
                    responsivePriority: 1
                },
                {
                    title: "Customer ID",
                    data: "customer_id",
                    name: "customer_id",
                    defaultContent: '',
                    responsivePriority: 2
                },
                {
                    title: "Company",
                    data: "company.name",
                    name: "company_id",
                    defaultContent: 'N/A',
                    responsivePriority: 2
                },
                {
                    title: "Order Total",
                    data: "financials",
                    name: "financials",
                    responsivePriority: 4,
                    render: (data, type, row) => {
                        if (row.financials.hasOwnProperty(0))
                            return TableViews.monetary(row.financials[0].overall_total);
                        return '';
                    }
                },
            ]
        }
    }

    static refundsTable() {
        return {
            ordering: false,
            columns: [
                {
                    title: "#",
                    data: "id",
                    name: "id",
                    responsivePriority: 1
                },
                {
                    title: "Method",
                    data: "method",
                    name: "method",
                    responsivePriority: 2
                },
                {
                    title: "Amount",
                    data: "amount",
                    name: "amount",
                    responsivePriority: 1
                },
                {
                    title: "User",
                    data: "user.name",
                    name: "user.name",
                    responsivePriority: 1
                },
                {
                    title: "Note",
                    data: "note",
                    name: "note",
                    responsivePriority: 2
                },
            ]
        }
    }

    static orderPaymentsTable() {
        return {
            ordering: false,
            columns: [
                {
                    title: "#",
                    data: "id",
                    name: "id",
                    responsivePriority: 1
                },
                {
                    title: "Method",
                    data: "method",
                    name: "method",
                    responsivePriority: 2
                },
                {
                    title: "Total",
                    data: "total",
                    name: "total",
                    responsivePriority: 1
                }
            ]
        }
    }

    static refillLevelTable() {
        return {
            ordering: false,
            dom: 'Brtip',
            buttons: [
                {
                    text: 'Stock Order',
                    action: function (e, dt, node, config) {
                        const $body = $(dt.body()[0]);

                        let data = [], url = '/products/stock/orders/create?';

                        $('tr', $body).each((key, row) => {

                            if (!$('.stockRefillCheckbox', row).is(':checked'))
                                return false;

                            let rowData = dt.row(row).data();

                            data.push(rowData.id)

                        });

                        let dataQuery = data.map(function (el, idx) {
                            return 'products[' + idx + ']=' + el;
                        }).join('&')

                        location.replace('/products/stock/orders/create?' + dataQuery);

                    }
                }
            ],
            columns: [
                {
                    title: "#",
                    data: "id",
                    name: "id",
                    responsivePriority: 1
                },
                {
                    title: "SKU",
                    data: "sku",
                    name: "sku",
                    responsivePriority: 2
                },
                {
                    title: "Stock Level",
                    data: "stock_level",
                    name: "stock_level",
                    responsivePriority: 2
                },
                {
                    title: '',
                    defaultContent: '',
                    render: (createElement, context) => {
                        return '<input class="stockRefillCheckbox table-checkbox" type="checkbox"/>'
                    }
                }
            ]
        }
    }

    static stockTakeTable() {
        return {
            lengthChange: true,
            pageLength: 100,
            columns: [
                {
                    title: "SKU",
                    data: "sku",
                    name: "sku",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 2
                },
                {
                    title: "Product Name",
                    data: "name",
                    name: "name",
                    filter: {
                        type: "text"
                    },
                    responsivePriority: 2
                },
                {
                    title: "Quantity",
                    data: "quantity",
                    name: "quantity",
                    responsivePriority: 2,
                    render: (data, type, row) => {
                        return `<input class="form-control stock-take-item" name="product_${row.id}" type="number" step="1" value="${data}" data-original-value="${data}" data-cost-per-unit="${row.cost}" data-product-id="${row.id}"/>`;
                    }
                },
                {
                    title: "Cost Per Unit",
                    data: "cost",
                    name: "cost",
                    responsivePriority: 2,
                    render: (data) => {
                        const value = TableViews.monetary(data);
                        return `<span>${value}</span>`;
                    }
                },
                {
                    title: "Cost",
                    data: "total_cost",
                    name: "total_cost",
                    responsivePriority: 2,
                    render: (data, type, row) => {
                        const value = TableViews.monetary(data);
                        return `<span id="total_cost_${row.id}">${value}</span>`;
                    }
                },
            ]
        }
    }
}
